/**
 * The invoice worklists' titles and empty states, with and without a 2B (N27, UI-S9-01).
 *
 * Before any GSTR-2B is imported nobody has compared anything: a books list titled "ITC at risk"
 * and an empty 2B list reading "Nothing here." both assert a result no one has found.
 */
export interface WorklistWords {
  title: string
  empty: string
}

export function worklistWords(kind: 'books' | 'tb', imported: boolean): WorklistWords {
  if (kind === 'books') {
    return imported
      ? { title: 'Books-only — ITC at risk', empty: 'Nothing here.' }
      : { title: 'Books — no 2B to compare yet', empty: 'No purchases on the books for this month.' }
  }
  return imported
    ? { title: '2B-only — books missing', empty: 'Nothing here.' }
    : { title: '2B-only — books missing', empty: 'No 2B imported yet.' }
}
